import api from './api';

const protheusPaymentsService = {
  async getClientData(cpf) {
    const cleanCpf = String(cpf || '').replace(/\D/g, '').trim();
    return api.get(`/api/protheus/payments/client?cpf=${encodeURIComponent(cleanCpf)}`);
  },
  async generatePix(cpf, payload) {
    const cleanCpf = String(cpf || '').replace(/\D/g, '').trim();
    return api.post(`/api/protheus/payments/pix?cpf=${encodeURIComponent(cleanCpf)}`, payload);
  }
};

export default protheusPaymentsService;

